<template>
  <base-section background-style="dark">
    <motion.div
        class="skills-header"
        :initial="{ opacity: 0, y: 30 }"
        :whileInView="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.6 }"
        :inViewOptions="{ once: true }"
    >
      <gradient-title text="Meine Fähigkeiten" tag="h2" />
      <p class="skills-subtitle">Technologien und Tools, mit denen ich arbeite</p>
    </motion.div>

    <div class="skills-grid">
      <feature-card
          v-for="(skill, index) in skills"
          :key="skill.name"
          :title="skill.name"
          :description="skill.description"
          :icon="skill.icon"
          :index="index"
      />
    </div>
  </base-section>
</template>

<script lang="ts" setup>
import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import FeatureCard from "@/components/FeatureCard.vue"

const skills = [
  {
    name: 'PHP & Laravel',
    icon: 'laravel-original.svg',
    description: 'Backend-Entwicklung mit Fokus auf saubere APIs, DDD und Performance in Laravel'
  },
  {
    name: 'Vue.js',
    icon: 'vuejs-plain.svg',
    description: 'Frontend-Entwicklung mit Vue 3 und der Composition API für moderne SPAs'
  },
  {
    name: 'TypeScript',
    icon: 'typescript-plain.svg',
    description: 'Für robustere Frontends, besseres Refactoring und weniger Laufzeitfehler'
  },
  {
    name: 'Docker',
    icon: 'docker-plain.svg',
    description: 'Containerisierung für eine einheitliche Entwicklungsumgebung'
  },
  {
    name: 'Kubernetes',
    icon: 'kubernetes-plain.svg',
    description: 'Orchestrierung von Containern in der Cloud'
  },
  {
    name: 'Storyblok',
    icon: 'storyblok.svg',
    description: 'Headless CMS zur flexiblen Content-Verwaltung'
  }
]
</script>

<style scoped>
.skills-header {
  text-align: center;
  margin-bottom: 4rem;
}

.skills-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
}

@media (max-width: 768px) {
  .skills-subtitle {
    font-size: 1rem;
  }

  .skills-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
</style>
